import Config from '@config';
import { initializeAuditApi } from '@gasbi/shared/common/features';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { AuditEntityTypeName } from './types';

const audit = initializeAuditApi<AuditEntityTypeName>({
  baseUrl: Config.VITE_AUDIT_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  auditApi,
  useGetAuditInfoQuery,
  useGetAuditEntryDetailsQuery,
  useGetAuditEntriesInfiniteQuery,
  useAuditEntityTypeNameTranslationSelector,
} = audit;
